import type { ReviewerStateValues } from '@/types/github';
import { Check, CircleOff, MessageSquare, X } from 'lucide-react';
import type { ReactElement } from 'react';

import { RequestedReviewIcon } from './requested-review-icon';

import { ReviewerState } from '@/types/github';

const REVIEWER_STATE_ICON_SIZE = 14;

/** How each reviewer state is shown: its icon and the label used for tooltips and screen readers. */
export const reviewerStateDisplay: Record<
  ReviewerStateValues,
  { icon: ReactElement | null; label: string }
> = {
  [ReviewerState.CHANGES_REQUESTED]: {
    icon: <X className="text-red-500" size={REVIEWER_STATE_ICON_SIZE} />,
    label: 'Requested changes',
  },
  [ReviewerState.REQUESTED_REVIEW]: {
    icon: <RequestedReviewIcon />,
    label: 'Review requested',
  },
  [ReviewerState.COMMENTED]: {
    icon: <MessageSquare className="text-zinc-500" size={REVIEWER_STATE_ICON_SIZE} />,
    label: 'Commented',
  },
  [ReviewerState.APPROVED]: {
    icon: <Check className="text-green-700" size={REVIEWER_STATE_ICON_SIZE} />,
    label: 'Approved',
  },
  [ReviewerState.DISMISSED]: {
    icon: <CircleOff className="text-zinc-500" size={REVIEWER_STATE_ICON_SIZE} />,
    label: 'Review dismissed',
  },
};
